/**
 * @author Ivan Toth.
 */
var lockBind = { comp: '=' };
var DetailLockController = (function () {
    function DetailLockController(topic) {
        this.topic = topic;
        return;
    }
    DetailLockController.$inject = ['topic'];
    return DetailLockController;
}());
var DetailLockComponent = (function () {
    function DetailLockComponent() {
        this.bindings = lockBind;
        this.templateUrl = 'lock.html';
        this.controller = DetailLockController;
    }
    return DetailLockComponent;
}());
angular
    .module('application')
    .component('lockSection', new DetailLockComponent());

//# sourceMappingURL=detail.gov.check.component.js.map
